import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Bg from '../../images/shapes/memecoin_bg_shape_2.svg'
import Bg2 from '../../images/shapes/shape_net_2.svg'

const LogoDesignTestimonial = () => {

    const testimonials = [
        {
            id: 1,
            paragraph: "I was blown away by how well they captured my brand’s vibe. The logo didn’t just look good—it felt right. Super easy to work with and delivered on time!",
            title: "Sarah T.",
            position: " Boutique Owner",
        },
        {
            id: 2,
            paragraph: "We had a rough idea of what we wanted, and GetLogoAndWebsite turned it into something far better than we imagined. It’s modern, clean, and instantly recognizable.",
            title: "Daniel K.",
            position: "Startup Founder",
        },
        {
            id: 3,
            paragraph: "From day one, they listened, understood our story, and turned it into a visual identity we’re proud of. Our new logo brought in compliments from clients!",
            title: "Linda P.",
            position: "Marketing Director",
        },
        {
            id: 4,
            paragraph: "Fast, friendly, and full of ideas! These guys took our messy thoughts and made something sleek and professional. Worth every penny.",
            title: "James R.",
            position: "Agency Co-Founder",
        },
        {
            id: 5,
            paragraph: "Their creative team has serious talent. Not only did they deliver a stunning logo, but they also made sure it aligned perfectly with our brand values.",
            title: "Maria S.",
            position: "E-commerce Brand Owner",
        },
    ];

    var settings = {
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        arrows: true,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 340,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <section id="id_memecoin_service_section"
            className={`memecoin_service_section z-2 position-relative testimonials`}
            style={{ backgroundImage: `url(${Bg})`, padding:"50px 0"}}
        >
            <div className="container">
                <div className="memecoin_heading_block text-center">
                    <h2 className="heading_text text-uppercase mb-0">
                        WHAT CLIENTS <br /> SAY ABOUT US
                    </h2>
                    <p className="mt-4">The Secret of our long term success in the industry lies in the heart of our customers</p>
                </div>

                <div className="text-left" data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
                    <Slider {...settings}>
                        {testimonials.map((item, index) => (
                            <div className="" key={index}>
                                <p className="px-3">{item.paragraph}</p>
                                <h4 className="px-3">{item.title}</h4>
                                <p className="px-3">{item.position}</p>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default LogoDesignTestimonial;
